import * as yup from "yup";

export const validationAddYourTeamSchema = (members) => {
  const isMembersEmpty = !members || members.length === 0;
  return yup.object().shape({
    first_name: yup
      .string()
      .trim()
      .test("first_name-validation", "First name is required.", async function (value) {
        const { last_name } = this.parent;
        if (isMembersEmpty) {
          return !!value;
        }
        if (last_name && !value) {
          return false;
        }
        return true;
      }),

    last_name: yup
      .string()
      .trim()
      .test("last_name-validation", "Last name is required", async function (value) {
        const { first_name } = this.parent;
        if (isMembersEmpty) {
          return !!value;
        }
        if (first_name && !value) {
          return false;
        }
        return true;
      }),
    job_type_ids: yup.array(),
    role: yup.string().oneOf(["Owner", "Member"]),
    weekly_worker_capacity: yup.array(),
  });
};
